export const neutronUrl = import.meta.env.VITE_NEUTRON_URL;

export const lunaUrl = import.meta.env.VITE_LUNA_URL;

export const personaEnvironmentId = import.meta.env.VITE_PERSONA_ENVIRONMENT_ID;

export const environment = import.meta.env.MODE.toLowerCase().includes('production')
  ? 'production'
  : 'development';

export function getSenderPhoneNumber() {
  const senderPhoneNumber = import.meta.env.VITE_SENDER_PHONE_NUMBER;

  if (!senderPhoneNumber) {
    throw new Error('SENDER_PHONE_NUMBER is not defined');
  }

  return senderPhoneNumber;
}

function getUnleashUrl() {
  const neutron_url = import.meta.env.VITE_NEUTRON_URL;
  if (!neutron_url) {
    throw new Error('NEUTRON_URL is not defined');
  }
  return new URL('/feature-flag/proxy', neutron_url).toString();
}

export const unleashConfig = {
  url: getUnleashUrl(),
  appName: import.meta.env.VITE_UNLEASH_APP_NAME,
  clientKey: import.meta.env.VITE_UNLEASH_CLIENT_KEY,
  environment
};
